(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aquamid-videos"] && !Shopify.designMode) return;
  try {
    
  class AquamidVideos extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-video-track]');
      this.querySelector('[data-video-prev]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-video-next]')?.addEventListener('click', () => this.move(1));
    }
    move(direction) {
      const card = this.track?.querySelector('.aquamid-videos__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
  }
  if (!customElements.get('aquamid-videos')) customElements.define('aquamid-videos', AquamidVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.site-header__menu').forEach((menu) => {
    const toggle = menu.querySelector('summary');
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.removeAttribute('open');
        toggle?.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
